import { Box, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  REACT_INTEGRATION_ACCESS_LEVEL_LIST,
  REACT_INTEGRATION_CARD_HOLDER_LIST,
} from "../../actions/EndPoints";
import { ReactComponent as DeleteIconHeader } from "../../assets/images/VisitingAccessLevels/Delete.svg";
import { ReactComponent as DeleteIconHover } from "../../assets/images/VisitingAccessLevels/DeleteIconHover.svg";
import { ReactComponent as CreateIcon } from "../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  deleteEmployeeMappedIntegration,
  getEmployeeMappedIntegration,
} from "../../slices/Employee/EmployeeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import EmployeeDeleteIcon from "../Employee/EmployeeDeleteIcon";
import RefreshIcon from "../VisitingAccessLevels/RefreshIcon";

export default function IntegrationAssigmentToEmployee(props) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [integrationList, setIntegrationList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { darkMode } = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);
  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });

  useEffect(() => {
    loadIntegrationList(paging);
  }, [paging]);

  const loadIntegrationList = async (paging) => {
    const payload = {
      id: props?.location?.state?.id,
      pageNumber: paging.pageNumber,
      pageSize: paging.pageSize,
      integrationType: props?.location?.state?.integrationType,
    };

    try {
      const data = await dispatch(
        getEmployeeMappedIntegration(payload),
      ).unwrap();

      if (data.code === "MSGS4000") {
        setIntegrationList(data.data.integrationMapping);
        setPage(data.data.curPage);
        setTotalPages(data.data.totalPages);
        setTotalRecords(data.data.totalCount);
      } else {
        setIntegrationList([]);
      }
    } catch (error) {
      setIntegrationList([]);
    }
  };

  const handleDeleteIntegration = (rows) => {
    const integrationIds = rows.map((item) => item.id);
    const integrationTypes = rows.map((item) => item.integrationType);

    dispatch(
      deleteEmployeeMappedIntegration({
        ids: integrationIds,
        integrationTypes,
      }),
    )
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4109" || data.code === "MSGS4110") {
          Toast(t(data.message), "success");
          loadIntegrationList(paging);
        }
      });
  };

  const handleBack = () => {
    history.push("/vis/person");
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);

    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const columns = [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: () => <div />,
    },
    {
      field: "name",
      headerName: t("COMMON044"),
      flex: 1,
      valueGetter: (params) => params.row.integrationName,
    },
    {
      field: "integrationName",
      headerName: t("Integration Name"),
      flex: 1,
      valueGetter: (params) => params.row.integrationType,
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 1,
      width: 150,
      headerAlign: "center",

      getActions: (params) => [
        <GridActionsCellItem
          icon={<EmployeeDeleteIcon />}
          label="Delete"
          onClick={() => handleAddIconClick(params.row)}
        />,
      ],
    },
  ];

  const onSelectionRowdata = (ids) => {
    const selectedData = integrationList.filter((row) => ids.includes(row.id));

    setSelectedRows(selectedData);
  };

  const handleAddIconClick = (row) => {
    handleDeleteIntegration([row]);
  };

  const handleSubmit = () => {
    if (!selectedRows.length) {
      Toast("Please select at least one record", "warning");
      return;
    }

    handleDeleteIntegration(selectedRows);
  };

  return (
    <>
      <HeaderToolbar
        title={
          props?.location?.state?.integrationType?.includes("ACCESS_LEVEL")
            ? t("Integration Access Level")
            : t("Integration Group")
        }
        back_button={true}
        onBack={handleBack}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
          mb: 1,
          flexWrap: "wrap",
        }}
      >
        <Tooltip title={t("Delete")}>
          <Box
            item
            className={darkMode ? "importdark" : "import"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleSubmit}
          >
            {isHovered ? (
              <DeleteIconHover
                style={{ color: darkMode ? "#fff" : "#474a4e" }}
              />
            ) : (
              <DeleteIconHeader
                style={{ color: darkMode ? "#fff" : "#474a4e" }}
              />
            )}
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box
            className="refreshIcon"
            onClick={() => loadIntegrationList(paging)}
            sx={{ cursor: "pointer" }}
          >
            <RefreshIcon />
          </Box>
        </Tooltip>

        <Tooltip
          title={
            props?.location?.state?.integrationType?.includes("ACCESS_LEVEL")
              ? t("Add Access Level")
              : t("Add Group")
          }
        >
          <Box
            className="addIcon"
            onClick={() => {
              if (
                props?.location?.state?.integrationType?.includes(
                  "ACCESS_LEVEL",
                )
              ) {
                history.push({
                  pathname: REACT_INTEGRATION_ACCESS_LEVEL_LIST,
                  state: {
                    id: props.location?.state?.id,
                  },
                });
              } else {
                history.push({
                  pathname: REACT_INTEGRATION_CARD_HOLDER_LIST,
                  state: {
                    id: props.location?.state?.id,
                  },
                });
              }
            }}
          >
            <CreateIcon />
          </Box>
        </Tooltip>
      </Box>

      <Box sx={{ width: "100%" }}>
        <DataTableLatest
          checkboxSelection
          columns={columns}
          rows={integrationList}
          page={page}
          count={totalRecords}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
          onSelectionModelChange={onSelectionRowdata}
        />
      </Box>
    </>
  );
}
